<template>
  <div class="app-balance-tariff-info-wrapper">
    <TariffInfoModal :show.sync="showInfoModal" :tariff="fullTariffs">
      <template v-for="slot in possibleChildSlotsFor('TariffModal')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </TariffInfoModal>
    <BalanceInfo :balance="currentCustomer.balance">
      <template v-for="slot in possibleChildSlotsFor('BalanceInfo')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </BalanceInfo>
    <TariffInfo :bookedTariff="fullTariffs" v-if="testFullTariffs" @show-info="showModal">
      <template v-for="slot in possibleChildSlotsFor('TariffInfo')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </TariffInfo>
    <div v-else>{{ tariffs.bookedTariff.name }}</div>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import TariffInfo from '@/components/process/generic/Tariff/generic/TariffInfo.vue'
import BalanceInfo from '@/components/process/generic/Tariff/lidl/BalanceInfo.vue'
import TariffInfoModal from '@/components/process/generic/Tariff/generic/CurrentTariff/TariffInfoModal.vue'
import slotProxy from '@/mixins/slotProxy'
import joinTariffExtra from '@/helper/joinTariffExtras'
import extraData from '@/mixins/extraData'

export default {
  name: 'BalanceTariffInfoWrapper',
  components: { TariffInfo, BalanceInfo, TariffInfoModal },
  data () {
    return {
      tariffs: {
        bookedTariff: {
          tariffId: '',
          name: '',
          runtime: {
            amount: null,
            unit: ''
          },
          phoneFlat: '',
          basicFee: null,
          smsFlat: ''
        }
      },
      currentCustomer: {
        balance: null
      },
      showInfoModal: false
    }
  },
  computed: {
    fullTariffs: function () {
      return joinTariffExtra(this.tariffs.bookedTariff, this.extraData)
    },
    testFullTariffs: function () {
      const searchResult = this.extraData.find((tariff) => {
        return tariff.id === this.tariffs.bookedTariff.tariffId
      })
      if (searchResult === undefined) {
        return false
      }
      return true
    }
  },
  methods: {
    showModal () {
      this.showInfoModal = true
    }
  },
  watch: {
    tariffs: function (tariffs) {
      document.dispatchEvent(new CustomEvent('hideTariffs', { detail: tariffs.bookedTariff.tariffId }))
    }
  },
  apollo: {
    tariffs: function () {
      return wrapQuery(gql`query {
        tariffs {
          bookedTariff {
          bandwidth {
            down
            up
          }
            tariffId,
            name,
            runtime {
              amount,
              unit
            },
            phoneFlat,
            basicFee,
            smsFlat,
            renewContractDate
            isPendingTariff
            changeTariffDate
            terminationDate
          }
        }
      }`, this, 'tariffs')
    },
    currentCustomer: function () {
      return wrapQuery(gql`query balanceInfo {
        currentCustomer {
          balance
        }
      }`, this, 'currentCustomer')
    }
  },
  mixins: [
    slotProxy(),
    extraData()
  ]
}
</script>
